module.exports = __webpack_public_path__ + "static/media/599.7554(24).eb5e8b7d.pdf";